import { apiSlice } from "../store/api/adminApi"

export type OrganizerSmsAudience =
  | 'allOrganizers'
  | 'activeOrganizers'
  | 'notActiveOrganizers'

export type EventSmsKind =
  | 'resendBuyers'
  | 'notifyHolders'
  | 'customBuyers'
  | 'customHolders'

export type SendOrganizerSmsOtpBody = {
    audience?: OrganizerSmsAudience
    testPhone?: string
    testUserName?: string
    textEn?: string
    textHe?: string
}

export type SendEventSmsOtpBody = {
    id: number
    kind: EventSmsKind
    textEn?: string
    textHe?: string
    testPhone?: string
    testUserName?: string
}

export const smsAdminApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        sendOrganizerSmsOtp: build.mutation<any, SendOrganizerSmsOtpBody>({
            query: (body) => ({
                url: `/admin/notification/sms/otp`,
                method: 'POST',
                body,
            }),
        }),
        confirmSendOrganizerSms: build.mutation<{ isTest: boolean; userId?: number }, { code: string }>({
            query: ({ code }) => ({
                url: `/admin/notification/sms/send`,
                method: 'POST',
                body: { code },
            }),
        }),
        sendEventSmsOtp: build.mutation<any, SendEventSmsOtpBody>({
            query: ({ id, ...body }) => ({
                url: `/admin/events/${id}/sms/otp`,
                method: 'POST',
                body,
            }),
        }),
        confirmSendEventSms: build.mutation<any, { id: number; code: string }>({
            query: ({ id, code }) => ({
                url: `/admin/events/${id}/sms/send`,
                method: 'POST',
                body: { code },
            }),
        }),
    }),
})
